/* 布局 */
//前台
import Layout from "@views/layout";

const ebookarticleRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "ebookarticle",
            name: "EBOOKARTICLE",
            meta: {
                title: "电子期刊文章管理",
                sort: 1,
            },
            component: () => import("@views/business/ebookarticle/index.vue"),
            redirect: {
                name: "EBOOKARTICLE_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "EBOOKARTICLE_LIST",
                    meta: {
                        title: "电子期刊文章管理",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/ebookarticle/list.vue"),
                },
                                {
                    path: "add",
                    name: "EBOOKARTICLE_ADD",
                    meta: {
                        title: "新增电子期刊文章管理",
                        parentPath: '/business/ebookarticle/list',
                        operate: true,
                    },
                    component: () => import("@views/business/ebookarticle/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "EBOOKARTICLE_EDIT",
                    meta: {
                        title: "编辑电子期刊文章管理",
                        parentPath: '/business/ebookarticle/list',
                        operate: true,
                    },
                    component: () => import("@views/business/ebookarticle/form.vue"),
                },
                                        ],
    },


        ],
};

export default ebookarticleRouter;
